import { render, staticRenderFns } from "./AddDocumentationPage.vue?vue&type=template&id=f7cf6826"
import script from "./AddDocumentationPage.vue?vue&type=script&lang=js"
export * from "./AddDocumentationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports